import { toggleFooterSuggestionsAction } from "@src/layout/store/actions";
import { getAwsAssets } from "@src/utils";
import { t } from "i18next";
import { Image } from "@src/components/Image";
import React from "react";
import { useDispatch } from "react-redux";
import { toggleRecentActivitySuggestions } from "../../../BottomSheets/store/actions";
import Popup from "../../Popup";

import style from "./FooterItem.module.scss";

function RemoveSuggestion() {
  // DISPATCH
  const dispatch = useDispatch();

  const removeSuggestions = () => {
    dispatch(toggleFooterSuggestionsAction(false));
    handleClose();
  };

  const handleClose = () => {
    dispatch(toggleRecentActivitySuggestions(false));
  };
  return (
    <Popup handleClose={handleClose}>
      <div className={style.RemoveSuggestions}>
        <Image
          src={getAwsAssets("ClosePrompt.svg", "bottomSheets")}
          className="SVGCoupons"
          height="48"
          width="48"
          alt="X"
        />

        <h2>
          {t(
            "components.uiElements.footer.footerItem.removeSuggestion.removeSuggestionHeading",
            "Remove Suggestions"
          )}
        </h2>
        <p>
          {t(
            "components.uiElements.footer.footerItem.removeSuggestion.removeSuggestionText",
            "It’s time to focus on your learnings"
          )}
          .
        </p>
        <p>
          {t(
            "components.uiElements.footer.footerItem.removeSuggestion.removeSuggestionPrompt",
            "Are you sure you want to remove all the suggestions"
          )}
          ?
        </p>
        <button onClick={removeSuggestions}>
          {t(
            "components.uiElements.footer.footerItem.removeSuggestion.removeSuggestionButtonText",
            "YES, REMOVE"
          )}
        </button>
      </div>
    </Popup>
  );
}

export default RemoveSuggestion;
